export default {
  xs: "1.2rem",
  xsm: "2rem",
  sm: "2.4rem",
  md: "4.4rem",
  lg: "10rem"
};